export default "ALTER TABLE `recurring_transactions` ADD `skipped_dates` text;";